webpackJsonp([263791100135453],{

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactEmotion = __webpack_require__(17);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, About);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  About.prototype.render = function render() {
	    var data = this.props.data;
	
	    var assetNumber = data.allContentfulAboutQuestion.edges.length;
	    var assetHalf = Math.floor(assetNumber / 2);
	    return _react2.default.createElement(
	      'div',
	      { className: container },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Allexa D\'Alessio | ' + data.contentfulSitePage.name
	        )
	      ),
	      _react2.default.createElement(
	        Title,
	        { background: data.contentfulSitePage.background },
	        data.contentfulSitePage.name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: content },
	        _react2.default.createElement(
	          'div',
	          { className: left },
	          data.allContentfulAsset.edges.map(function (_ref, index) {
	            var node = _ref.node;
	            return _react2.default.createElement('img', { key: index, className: image, src: node.sizes.src });
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: right },
	          this.props.data.allContentfulAboutQuestion.edges.map(function (_ref2, index) {
	            var node = _ref2.node;
	            return _react2.default.createElement(
	              'div',
	              { className: question__container, key: index },
	              _react2.default.createElement(
	                Question,
	                { background: data.contentfulSitePage.background },
	                node.question
	              ),
	              _react2.default.createElement('p', {
	                dangerouslySetInnerHTML: {
	                  __html: node.answer.answer
	                }
	              })
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: attribution },
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://www.contentful.com/',
	              rel: 'nofollow',
	              target: '_blank'
	            },
	            _react2.default.createElement('img', {
	              src: 'https://images.contentful.com/fo9twyrwpveg/44baP9Gtm8qE2Umm8CQwQk/c43325463d1cb5db2ef97fca0788ea55/PoweredByContentful_LightBackground.svg',
	              alt: 'Powered by Contentful'
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return About;
	}(_react.Component);
	
	About.propTypes = {};
	About.defaultProps = {};
	exports.default = About;
	
	
	var container = /*#__PURE__*/(0, _reactEmotion.css)();
	var Title = /*#__PURE__*/(0, _reactEmotion2.default)('h1', {
	  target: 'eeh46vk0'
	})('color:', function (_ref3) {
	  var background = _ref3.background;
	  return background || 'inherit';
	}, ';margin:25px auto 0 auto;padding:0 25px 0 25px;max-width:calc(1000px + (25px * 2));@media (min-width:650px){padding:35px 25px 0 25px;}');
	var Question = /*#__PURE__*/(0, _reactEmotion2.default)('h3', {
	  target: 'eeh46vk1'
	})('background-color:', function (_ref4) {
	  var background = _ref4.background;
	  return background || '#222';
	}, ';color:white;margin-bottom:15px;padding:0 5px 2px 5px;font-weight:200;');
	var question__container = /*#__PURE__*/(0, _reactEmotion.css)('&:last-of-type{padding-bottom:60px;}');
	var content = /*#__PURE__*/(0, _reactEmotion.css)('width:100%;margin:25px auto 0 auto;padding:0 25px 0 25px;max-width:calc(1000px + (25px * 2));display:flex;flex-wrap:wrap;@media (min-width:650px){flex-wrap:nowrap;}');
	var left = /*#__PURE__*/(0, _reactEmotion.css)('width:100%;@media (min-width:650px){width:64%;margin:0 20px 0 0;}');
	var right = /*#__PURE__*/(0, _reactEmotion.css)('width:100%;@media (min-width:650px){width:36%;margin:0 0 0 20px;}');
	var image = /*#__PURE__*/(0, _reactEmotion.css)('width:100%;vertical-align:top;&:nth-of-type(1){padding:0 0 30px 0;max-height:350px;object-fit:cover;object-position:50% 0;}&:nth-of-type(n + 2){display:none;}@media (min-width:650px){&:nth-of-type(1){max-height:100%;padding:0;}&:nth-of-type(n + 1){display:block;}}');
	var attribution = /*#__PURE__*/(0, _reactEmotion.css)('position:absolute;width:100px;bottom:0;right:30px;');
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-06eec4507200747baff5.js